const checkTransform = (panel) => {
  const transformValue = getComputedStyle(panel).transform;

  if (transformValue !== 'none') {
    const matrix = new DOMMatrix(transformValue);
    if (matrix.m42 !== 0) {
      panel.classList.add('translated');
    } else {
      panel.classList.remove('translated');
    }
  }
};

const observeStyleChanges = (panel) => {
  const observer = new MutationObserver(() => {
    checkTransform(panel);
  });

  observer.observe(panel, { attributes: true, attributeFilter: ['style'] });

  checkTransform(panel);
};

const observePanelChanges = () => {
  const panel = document.querySelector('.snize-main-panel');

  if (panel) {
    observeStyleChanges(panel);
  } else {
    const parentObserver = new MutationObserver(() => {
      const newPanel = document.querySelector('.snize-main-panel');
      if (newPanel) {
        observeStyleChanges(newPanel);
        parentObserver.disconnect();
      }
    });

    parentObserver.observe(document.body, { childList: true, subtree: true });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  observePanelChanges();
});
window.addEventListener('scroll', () => {
  const panel = document.querySelector('.snize-main-panel');
  checkTransform(panel);
});
